<div class="modal-header">
    <h4 class="modal-title">Faktura</h4>
    <button (click)="onDismiss()" type="button" data-bs-theme="dark" class="btn-close" aria-label="Close" tabindex="-1"></button>
</div>

<div class="modal-body">
    <app-invoices-options
        [searchFor]="searchFor"
        (filterOptions)=onFilterOptions($event)
        (dateOptions)="onDateOptions($event)"
        (godkendMarked)="godkendMarked()"
    ></app-invoices-options>
    <div class="table__viewport">
        <app-invoices-list
            [invoices]="invoices$ | async"
            [filterOptions]="filterOptions"
            [markable]="true"
            (markedInvoices)="onMarkedInvoices($event)"
            (reloadInvoices)="loadInvoices()"
        ></app-invoices-list>
    </div>
</div>
